import { useAccount, useConnect, useDisconnect, useNetwork } from 'wagmi';
import styled from 'styled-components'
import { InjectedConnector } from 'wagmi/connectors/injected'




const ConnectWallet = styled.div`
    margin-left: auto;
    color: white;
    margin-top: 1rem;
`

const Button = styled.button`
    box-sizing: border-box;
    border: none;
    // width: 100vw;
    // height: 100wh;
    width: 6rem;
    height: 3rem;
    font-style: normal;
    font-family: 'Inter';
    color: #FFFFFF;
    background: #A32E2E;
    mix-blend-mode: normal;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 30px;

    &:hover
    {
        color: black;
        scale: 1.1;
    }
`


export default function Connect() {
    const { address, isConnected } = useAccount();
    const { chain } = useNetwork()
    // const { data: ensName } = useEnsName({ address });
    const { connect } = useConnect();
    const { disconnect } = useDisconnect();


    return (
        // <ConnectWallet 
        // label="Sign in"
        // accountStatus={{
        //     smallScreen: 'address',
        //     largeScreen: 'full',
        // }} 
        // showBalance={{
        //     smallScreen: false,
        //     largeScreen: true,
        // }} 
        // />
        <ConnectWallet>
            {isConnected ? (
                <div>
                    <Button onClick={disconnect}>
                        {address.slice(0, 4) + '...' + address.slice(38, 42)}
                    </Button>
                    <br />
                    {/* {chain.id} */}
                </div>
            ) : (
                <Button onClick={() => connect({
                    connector: new InjectedConnector(),
                })} >
                    connect wallet
                </Button>
            )}
            {/* <button onClick={() => connect({
                connector: new InjectedConnector(),
            })} >
                connect wallet
            </button> */}
        </ConnectWallet>

    )
}